import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { InsuranceProduct } from "Store/interfaces/products/checkout";
import React from "react";
import { ProductDetailsTableRow } from "./ProductDetailsTableRow";
import { ProductDetailsTableRowDitto } from "./ProductDetailsTableRow/ProductDetailsTableRowDitto";
import { ProductDetail } from "./interface";
import { ProductDetails } from "./styled";

interface Props {
  readonly productDetails: ProductDetail[];
  readonly productText: any;
  readonly lang: string;
  readonly product: InsuranceProduct;
}

export const ProductDetailsTable = ({
  productDetails,
  productText,
  lang,
  product,
}: Props): React.ReactElement => {
  const isDittoImplementedInProductDetailsList =
    product.name === INSURANCE_NAME_VALUE.HOUSE ||
    product.name === INSURANCE_NAME_VALUE.ANIMAL;

  return (
    <ProductDetails>
      {productDetails.map((detail, index) => {
        return !isDittoImplementedInProductDetailsList ? (
          <ProductDetailsTableRow
            key={index}
            detail={detail}
            productText={productText}
            lang={lang}
          />
        ) : (
          <ProductDetailsTableRowDitto key={index} detail={detail} />
        );
      })}
    </ProductDetails>
  );
};
